import React, { useEffect, useState } from 'react';
import './AddReferral.css';
import { MdCancel } from 'react-icons/md';
import { FaCarSide } from "react-icons/fa";
import ReferralDS from '../../DataServices/ReferralDs'
import { useCustomContext } from '../CustomComponents/CustomComponents';
import { insertLog } from '../Logs/InsertLog';
import CustomDropdown from './CustomDropdown';
import { FaBuildingColumns, FaLocationDot } from 'react-icons/fa6';
import { FiUser } from 'react-icons/fi';


const EditReferralModal = ({ onClose, clientData, section, fetchReferralData }) => {
    const [customMake, setCustomMake] = useState("");
    const [customYear, setCustomYear] = useState("");
    const [errors, setErrors] = useState({});
    const [customCounty, setcustomCounty] = useState("")
    const referralAddedBy = localStorage.getItem('email');


    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "vehicleMake" && value !== "Other") {
            setCustomMake("");
        } else if (name === "vehicleYear" && value !== "Other") {
            setCustomYear("");
        } else if (name === "county" && value !== "Other") {
            setcustomCounty("");
        }

        if (name === "phoneNumber") {
            const digitsOnly = value.replace(/\D/g, ""); // remove non-digits
            if (!digitsOnly) {
                setErrors(prev => ({ ...prev, phoneNumber: "Phone number is required" }));
            } else if (digitsOnly.length !== 10) {
                setErrors(prev => ({ ...prev, phoneNumber: "Please enter exactly 10 digits" }));
            } else {
                setErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.phoneNumber;
                    return newErrors;
                });
            }
        }
        if (name === "dob") {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Ignore time part

            const enteredDate = new Date(value);
            enteredDate.setHours(0, 0, 0, 0);

            if (enteredDate > today) {

                showAlert(`Future dates are not allowed for Date of Birth.`, [
                    { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
                ]);
                return;
            }
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const referal = new ReferralDS();
    const { showAlert, hud, stopHudRotation, showToast } = useCustomContext();

    const [formData, setFormData] = useState({
        firstName: "",
        middleName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        emergencyPhone: "",
        dob: "",
        address: "",
        city: "",
        county: "",
        state: "",
        zip: "",
        vehicleModel: "",
        vehicleColor: "",
        ignitionType: "",
        vin: "",
        DriverlicenseNumber: "",
        licensePlate: "",
        courtName: "",
        courtAddress: "",
        vehicleMake: "",
        vehicleYear: "",
        notes: "",
    });

    const isOtherSelected = formData.vehicleMake === "Other";
    const isYearOther = formData.vehicleYear === "Other";

    useEffect(() => {
        if (clientData) {
            const updatedFormData = { ...clientData };

            // Vehicle Make
            if (clientData.vehicleMake) {
                if (!vehicleMakes.includes(clientData.vehicleMake)) {
                    updatedFormData.vehicleMake = "Other";
                    setCustomMake(clientData.vehicleMake);
                }
            }

            // Vehicle Year
            if (clientData.vehicleYear) {
                if (!years.includes(clientData.vehicleYear)) {
                    updatedFormData.vehicleYear = "Other";
                    setCustomYear(clientData.vehicleYear);
                }
            }

            // County
            if (clientData.county) {
                if (!counties.includes(clientData.county)) {
                    updatedFormData.county = "Other";
                    setcustomCounty(clientData.county);
                } else {
                    setcustomCounty("");
                }
            }

            setFormData(prev => ({
                ...prev,
                ...updatedFormData,
            }));
        }
    }, [clientData]);

   
    const iscountyOther = formData.county === "Other";
    const years = [...Array.from({ length: 2025 - 1990 + 1 }, (_, i) => 1990 + i)];

    const vehicleMakes = [
        "Acura", "Alfa Romeo", "Audi", "Bentley", "BMW", "Chevrolet", "Chrysler",
        "Dodge", "Fiat", "Ford", "GMC", "Honda", "Hyundai", "Infiniti", "Jaguar",
        "Jeep", "Kia", "Land Rover", "Lexus", "Lincoln", "Maserati", "Mazda",
        "Mercedes-Benz", "Mini", "Mitsubishi", "Nissan", "Porsche", "Ram",
        "Subaru", "Tesla", "Toyota", "Volkswagen", "Volvo"
    ];

    const counties = [
        "Atlantic",
        "Bergen",
        "Burlington",
        "Camden",
        "Cape May",
        "Cumberland",
        "Essex",
        "Gloucester",
        "Hudson",
        "Hunterdon",
        "Mercer",
        "Middlesex",
        "Monmouth",
        "Morris",
        "Ocean",
        "Passaic",
        "Salem",
        "Somerset",
        "Sussex",
        "Union",
        "Warren"
    ];
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split('@')[0];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};
        const { firstName, email, phoneNumber } = formData;

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\(?([0-9]{3})\)?[- ]?([0-9]{3})[- ]?([0-9]{4})$/;

        if (!firstName) newErrors.firstName = "First name is required";
        else if (firstName.length > 30) newErrors.firstName = "Max 30 characters";

        if (!email) newErrors.email = "Email is required";
        else if (!emailRegex.test(email)) newErrors.email = "Invalid email format";
        else if (email.length > 30) newErrors.email = "Max 30 characters";

        if (!phoneNumber) {
            newErrors.phoneNumber = "Phone number is required";
        } else if (!phoneRegex.test(phoneNumber.replace(/\D/g, ""))) {
            newErrors.phoneNumber = "Please enter exactly 10 digits";
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length !== 0) return;

        const finalData = {
            ...formData,
            vehicleMake: formData.vehicleMake === "Other" ? customMake : formData.vehicleMake,
            vehicleYear: formData.vehicleYear === "Other" ? customYear : formData.vehicleYear,
            county: formData.county === "Other" ? customCounty : formData.county,
            referralAddedBy
        };

        delete finalData.notes;
        delete finalData.addedTimestamp;
        delete finalData.updatedTimestamp;
        delete finalData.referralAddedBy;

        const changes = {};
        for (const key in finalData) {
            // Normalize both values to an empty string if they are null or undefined
            const clientValue = clientData[key] === null || clientData[key] === undefined ? "" : String(clientData[key]);
            const finalValue = finalData[key] === null || finalData[key] === undefined ? "" : String(finalData[key]);

            // Add extra trim() to catch cases where a user might clear the input but leave a space
            if (clientValue.trim() !== finalValue.trim()) {
                changes[key] = {
                    oldValue: clientValue,
                    newValue: finalValue
                };
            }
        }

        console.log("Detected changes:", changes);

        let logDescription = " ";
        if (Object.keys(changes).length === 0) {
            showAlert("No changes detected", [
                { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }
            ]);
            return;
        }

        if (Object.keys(changes).length > 0) {
            let sectionName = '';
            switch (section) {
                case 'personal':
                    sectionName = 'Personal Information';
                    break;
                case 'address':
                    sectionName = 'Address Information';
                    break;
                case 'vehicle':
                    sectionName = 'Vehicle Information';
                    break;
                case 'court':
                    sectionName = 'Court Information';
                    break;

            }
            logDescription = `${userName} made the changes in the ${sectionName}`;
        }

        try {
            hud("Please wait...");
            const response = await referal.RM_Referral_Update(finalData);

            const isSuccess = response?.data?.statusCode === 200;
            if (!isSuccess) throw new Error("Failed status code");

            const message =
                typeof response.data.body === "string"
                    ? JSON.parse(response.data.body).message
                    : response.data.body?.message;

            await insertLog(logDescription, clientData.referralID, useremail, hud, stopHudRotation, showAlert);

            onClose();
            if (typeof fetchReferralData === "function") {
                await fetchReferralData();
            }
         
            showToast({ message });
        } catch (error) {
            console.error("Referral update error:", error);
            showAlert("Something went wrong", [
                { label: "Ok", onClick: () => { }, color: "var(--buttonColor)" },
            ]);
        } finally {
            stopHudRotation();
        }
    };

    const countyOptions = [
        { label: "Select County", value: "" },  // placeholder option, disabled in dropdown
        ...counties.map(county => ({ label: county, value: county })),
        { label: "Other", value: "Other" }
    ];

    const VechileMakes = [
        { label: "Select Make", value: "" },  // placeholder selectable option
        ...vehicleMakes.map(vehicleMake => ({ label: vehicleMake, value: vehicleMake })),
        { label: "Other", value: "Other" }
    ];

    const Years = [
        { label: "Select Year", value: "" },  // placeholder selectable option
        ...years.map(vehicleYear => ({ label: vehicleYear, value: vehicleYear })),
        { label: "Other", value: "Other" }
    ];
    const handleKeyDown = (e) => {

        const allowedKeys = [
            'Backspace',
            'ArrowLeft',
            'ArrowRight',
            'Delete',
            'Tab',
            '.'
        ];

        if (!allowedKeys.includes(e.key) && !e.key.match(/[0-9]/)) {
            e.preventDefault();
        }
        if (e.key === '.' && e.target.value.includes('.')) {
            e.preventDefault();
        }
    };
    return (
        <div className="modal-overlay">
            <div className="modal-content-editreferral">
                <div className="modal-header">
                    <span className="modal-title">Edit Referral</span>
                    <MdCancel className="close-modal" size={24} onClick={onClose} />
                </div>

                <div className="modal-body">
                    <form onSubmit={handleSubmit} className="referral-form">
                        <>
                            {section === 'personal' && (
                                < fieldset >
                                    <legend><FiUser size={18} /> Personal Information</legend>
                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="firstName">First Name *</label>
                                            <input id="firstName" value={formData.firstName}
                                                onChange={handleChange} className="form-control" required name="firstName" type="text" />
                                            {errors.firstName && <span className="error-text">{errors.firstName}</span>}
                                        </div>
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="middleName">Middle Initial</label>
                                            <input
                                                value={formData.middleName} id="middleName"
                                                onChange={handleChange} className="form-control" name="middleName" type="text" />
                                        </div>
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="lastName">Last Name </label>
                                            <input id="lastName" className="form-control" value={formData.lastName}
                                                onChange={handleChange} name="lastName" type="text" />
                                        </div>
                                    </div>

                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="email">Email *</label>
                                            <input id="email" className="form-control" value={formData.email}
                                                onChange={handleChange} required name="email" type="email" />
                                            {errors.email && <span className="error-text">{errors.email}</span>}
                                        </div>
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="phoneNumber">Phone *</label>
                                            <input required className="form-control" value={formData.phoneNumber}
                                                onChange={handleChange} id="phoneNumber" name="phoneNumber" type="number"
                                                onKeyDown={handleKeyDown}
                                            />
                                            {errors.phoneNumber && <span className="error-text">{errors.phoneNumber}</span>}
                                        </div>
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="emergencyPhone">Emergency Phone </label>
                                            <input id="emergencyPhone" className="form-control" value={formData.emergencyPhone}
                                                onChange={handleChange} name="emergencyPhone" type="number"
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral dob-responsive">
                                            <label htmlFor="dob">Date of Birth </label>
                                            <input
                                                className="form-control"
                                                id="dob"
                                                value={formData.dob}
                                                onChange={handleChange}
                                                name="dob"
                                                type="date"
                                                max={new Date().toISOString().split("T")[0]} // Prevents future dates
                                            />
                                        </div>
                                    </div>


                                </fieldset>
                            )}
                            {section === 'address' && (
                                < fieldset >
                                    <legend><FaLocationDot size={18} /> Address Information</legend>
                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="address"
                                            >Address </label>
                                            <input id="address" className="form-control" onChange={handleChange} value={formData.address} name="address" type="text" />
                                        </div>
                                    </div>
                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="city">City </label>
                                            <input className="form-control" id="city" value={formData.city}
                                                onChange={handleChange} name="city" type="text" />
                                        </div>
                                        <div className="form-group form-group-referral">
                                            <CustomDropdown
                                                label="County"
                                                name="county"
                                                options={countyOptions}
                                                value={formData.county}
                                                onChange={handleChange}
                                                placeholder="Select County"
                                            />

                                        </div>
                                        {iscountyOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="county">Enter County</label>
                                                <input
                                                    className="form-control" id="customCounty"
                                                    onChange={(e) => setcustomCounty(e.target.value)} name="customCounty" type="text" value={customCounty}
                                                />
                                            </div>
                                        )}


                                        {!iscountyOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="state">State </label>

                                                <input className="form-control" id="state" value={formData.state}
                                                    onChange={handleChange} name="state" type="text" />
                                            </div>
                                        )}
                                    </div>
                                    <div className="form-row form-row-referral">
                                        {iscountyOther && (
                                            <div className="form-group form-group-referral dob-responsive">
                                                <label htmlFor="state">State </label>

                                                <input className="form-control" id="state" value={formData.state}
                                                    onChange={handleChange} name="state" type="text" />
                                            </div>
                                        )}
                                        <div className="form-group form-group-referral dob-responsive">
                                            <label htmlFor="zip" >ZIP Code </label>
                                            <input className="form-control" id="zip" value={formData.zip}
                                                onChange={handleChange} name="zip" type="text" />
                                        </div>
                                    </div>
                                </fieldset>

                            )}
                            {section === 'vehicle' && (
                                <fieldset>
                                    <legend><FaCarSide size={18} /> Vehicle Information</legend>

                                    {/* Row 1 */}
                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <CustomDropdown
                                                label="Vehicle Make"
                                                className="form-control form-row-referral-1"
                                                name="vehicleMake"   // corrected name here
                                                options={VechileMakes}
                                                placeholder="Vehicle Make"
                                                value={formData.vehicleMake}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        {isOtherSelected && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="customMake">Enter Make</label>
                                                <input
                                                    className="form-control"
                                                    id="customMake"
                                                    name="customMake"
                                                    type="text"
                                                    value={customMake}
                                                    onChange={(e) => setCustomMake(e.target.value)}
                                                />
                                            </div>
                                        )}

                                        <div className="form-group form-group-referral">
                                            <label htmlFor="vehicleModel">Vehicle Model</label>
                                            <input className="form-control" value={formData.vehicleModel}
                                                onChange={handleChange} id="vehicleModel" name="vehicleModel" type="text" />
                                        </div>

                                        {!isOtherSelected && (
                                            <div className="form-group form-group-referral">
                                                <CustomDropdown
                                                    label="Vehicle Year"
                                                    className="form-control form-row-referral-1"
                                                    name="vehicleYear"
                                                    options={Years}
                                                    placeholder="Vehicle Year"
                                                    value={formData.vehicleYear}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        )}
                                    </div>

                                    {/* Row 2 */}
                                    <div className="form-row form-row-referral">
                                        {isOtherSelected && (
                                            <div className="form-group form-group-referral">
                                                <CustomDropdown
                                                    label="Vehicle Year"
                                                    className="form-control form-row-referral-1"
                                                    name="vehicleYear"
                                                    options={Years}
                                                    placeholder="Select Vehicle Year"
                                                    value={formData.vehicleYear}
                                                    onChange={handleChange}
                                                />

                                            </div>

                                        )}
                                        {isYearOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="customYear">Enter year</label>
                                                <input
                                                    className="form-control"
                                                    id="customYear"
                                                    name="customYear"
                                                    type="text"
                                                    value={customYear}
                                                    onChange={(e) => setCustomYear(e.target.value)}
                                                />
                                            </div>
                                        )}

                                        <div className="form-group form-group-referral">
                                            <label htmlFor="vehicleColor">Vehicle Color</label>
                                            <input id="vehicleColor" value={formData.vehicleColor}
                                                className="form-control" onChange={handleChange} name="vehicleColor" type="text" />
                                        </div>

                                        {!isOtherSelected && isYearOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="ignitionType">Ignition Type</label>
                                                <select id="ignitionType" name="ignitionType"
                                                    className="form-control"
                                                    value={formData.ignitionType}
                                                    onChange={handleChange}>
                                                    <option value="">Select ignition type</option>
                                                    <option value="key">Key</option>
                                                    <option value="push-button">Push Button</option>
                                                </select>
                                            </div>
                                        )}

                                        {!isOtherSelected && !isYearOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="ignitionType">Ignition Type</label>
                                                <select id="ignitionType" name="ignitionType"
                                                    className="form-control"
                                                    value={formData.ignitionType}
                                                    onChange={handleChange}>
                                                    <option value="">Select ignition type</option>
                                                    <option value="key">Key</option>
                                                    <option value="push-button">Push Button</option>
                                                </select>
                                            </div>
                                        )}

                                        {!isYearOther && isOtherSelected && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="ignitionType">Ignition Type</label>
                                                <select id="ignitionType" name="ignitionType"
                                                    className="form-control"
                                                    value={formData.ignitionType}
                                                    onChange={handleChange}>
                                                    <option value="">Select ignition type</option>
                                                    <option value="key">Key</option>
                                                    <option value="push-button">Push Button</option>
                                                </select>
                                            </div>
                                        )}


                                        {!isYearOther && !isOtherSelected && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="vin">VIN</label>
                                                <input value={formData.vin}
                                                    className="form-control"
                                                    onChange={handleChange} id="vin" name="vin" type="text" />
                                            </div>
                                        )}

                                    </div>

                                    {/* Row 3 */}
                                    <div className="form-row form-row-referral">


                                        {isOtherSelected && isYearOther && (
                                            <div className="form-group form-group-referral">
                                                <label htmlFor="ignitionType">Ignition Type</label>
                                                <select id="ignitionType" name="ignitionType"
                                                    className="form-control"
                                                    value={formData.ignitionType}
                                                    onChange={handleChange}>
                                                    <option value="">Select ignition type</option>
                                                    <option value="key">Key</option>
                                                    <option value="push-button">Push Button</option>
                                                </select>
                                            </div>
                                        )}

                                        {isYearOther && !isOtherSelected && (
                                            <div className="form-group form-group-referral ">
                                                <label htmlFor="vin">VIN</label>
                                                <input id="vin" className="form-control" value={formData.vin}
                                                    onChange={handleChange} name="vin" type="text" />
                                            </div>
                                        )}
                                        {isYearOther && !isOtherSelected && (
                                            <div className="form-row form-row-referral dob-responsive">
                                                <div className="form-group form-group-referral ">
                                                    <label htmlFor="licensePlate">License Plate</label>
                                                    <input className="form-control" value={formData.licensePlate}
                                                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                                                </div>
                                            </div>
                                        )}
                                        {isOtherSelected && (
                                            <div className="form-group form-group-referral ">
                                                <label htmlFor="vin">VIN</label>
                                                <input id="vin" className="form-control" value={formData.vin}
                                                    onChange={handleChange} name="vin" type="text" />
                                            </div>
                                        )}
                                        {isOtherSelected && (
                                            <div className="form-group form-group-referral dob-responsive">
                                                <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                                                <input id="DriverlicenseNumber" className="form-control" value={formData.DriverlicenseNumber}
                                                    onChange={handleChange} name="DriverlicenseNumber" type="text" />
                                            </div>
                                        )}
                                        {isOtherSelected && !isYearOther && (
                                            <div className="form-row form-row-referral dob-responsive">
                                                <div className="form-group form-group-referral ">
                                                    <label htmlFor="licensePlate">License Plate</label>
                                                    <input className="form-control" value={formData.licensePlate}
                                                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                                                </div>
                                            </div>
                                        )}


                                        {!isOtherSelected && !isYearOther && (
                                            <div className="form-group form-group-referral dob-responsive">
                                                <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                                                <input className="form-control" value={formData.DriverlicenseNumber}
                                                    onChange={handleChange} id="DriverlicenseNumber" name="DriverlicenseNumber" type="text" />
                                            </div>
                                        )}
                                        {!isOtherSelected && isYearOther && (
                                            <div className="form-group form-group-referral dob-responsive">
                                                <label htmlFor="DriverlicenseNumber">Driver's License Number</label>
                                                <input className="form-control" value={formData.DriverlicenseNumber}
                                                    onChange={handleChange} id="DriverlicenseNumber" name="DriverlicenseNumber" type="text" />
                                            </div>
                                        )}
                                        {!isOtherSelected && !isYearOther && (
                                            <div className="form-row form-row-referral dob-responsive">
                                                <div className="form-group form-group-referral ">
                                                    <label htmlFor="licensePlate">License Plate</label>
                                                    <input className="form-control" value={formData.licensePlate}
                                                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                    <div className="form-row form-row-referral">


                                        {isYearOther && isOtherSelected && (
                                            <div className="form-row form-row-referral dob-responsive">
                                                <div className="form-group form-group-referral ">
                                                    <label htmlFor="licensePlate">License Plate</label>
                                                    <input className="form-control" value={formData.licensePlate}
                                                        onChange={handleChange} id="licensePlate" name="licensePlate" type="text" />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </fieldset>

                            )}
                            {section === 'court' && (
                                <fieldset>
                                    <legend><FaBuildingColumns size={16} /> Court Information</legend>

                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="courtName">Court Name</label>
                                            <input id="courtName" value={formData.courtName} className="form-control"
                                                onChange={handleChange} name="courtName" type="text" placeholder="Court Name" />
                                        </div>
                                    </div>
                                    <div className="form-row form-row-referral">
                                        <div className="form-group form-group-referral">
                                            <label htmlFor="courtAddress">Court Address</label>
                                            <input id="courtAddress" value={formData.courtAddress} className="form-control"
                                                onChange={handleChange} name="courtAddress" type="text" placeholder="Court Adress" />
                                        </div>
                                    </div>
                                </fieldset>
                            )}
                        </>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <button type="button" className="cancel-btn" onClick={onClose}>
                                Close
                            </button>
                            <button type="submit" className="submit-btn">
                                Update
                            </button>
                        </div>

                    </form>
                </div>
            </div >
        </div >
    );
};

export default EditReferralModal;